import React from 'react';
import ChangePasswordForm from "./ChangePasswordForm";
import {withRouter} from "react-router-dom";

/**
 * Change password page wrapper
 * @param history is used to enable router redirects.
 *      It utilizes HTML5 history API
 *      (pushState, replaceState and the popstate events)
 *      to keep your UI in sync with the URL.
 */
const ChangePasswordTab = ({history}) => {
    return (
        <div>
            <ChangePasswordForm history={history}/>
        </div>
    );
};

export default withRouter(ChangePasswordTab);



// WEBPACK FOOTER //
// ./src/components/account/changepassword/ChangePasswordTab.jsx